import { API, ApiService, StringFormat } from "@packages/common";
import { Inject, Injectable } from "@webmotors/ioc";
import {
  AutocompleteApiResponseDTO,
  AutocompleteItemDTO,
  AutocompleteMetadata,
} from "./dtos";

export enum VehicleType {
  CAR = "car",
  BIKE = "bike",
}

@Injectable("AutocompleteService")
export class AutocompleteService {
  /**
   * Autocomplete sevice constructor
   *
   * @param apiService
   */
  constructor(
    @Inject(API)
    private readonly apiService: ApiService
  ) {}

  /**
   * Fetch autocomplete items
   *
   * @param vehicleType
   * @returns
   */
  async fetchItems(
    vehicleType: VehicleType
  ): Promise<AutocompleteItemDTO<AutocompleteMetadata>[]> {
    const response = await this.apiService.get<
      unknown,
      AutocompleteApiResponseDTO[]
    >(`/filter/${vehicleType}/autocomplete`);

    const models: AutocompleteItemDTO<AutocompleteMetadata>[] = [];

    const makes: AutocompleteItemDTO<AutocompleteMetadata>[] = response.map(
      (make) => {
        make.items.forEach((model) => {
          models.push({
            value: model.name,
            label: StringFormat.capitalizeWords(`${make.name} ${model.name}`),
            metadata: {
              makes: [
                { name: "marca", value: make.name },
                { name: "modelo", value: model.name },
              ],
              vehicleType,
            },
          });
        });

        return {
          value: make.name,
          label: StringFormat.capitalizeWords(make.name),
          metadata: {
            makes: [{ name: "marca", value: make.name }],
            vehicleType,
          },
        };
      }
    );

    return [
      {
        value: "marca",
        label: "Marca",
        items: makes,
      },
      {
        value: "modelos",
        label: "Modelos",
        items: models,
      },
    ];
  }
}
